/**
 * Teardown MSG91 OTP provider script and all related DOM elements.
 * Call this when login components unmount to prevent captcha/widget from
 * persisting on other pages.
 */

export const MSG91_SCRIPT_ID = "msg91-otp-script";
const CAPTCHA_RENDER_ID = "captcha-id";

export const teardownMsg91 = (): void => {
  (window as any).isMSG91Active = false;

  // Remove MSG91 OTP provider web component
  const msg91Provider = document.querySelector("msg91-otp-provider");
  if (msg91Provider?.parentNode) {
    try {
      if ((msg91Provider as any).disconnectedCallback) {
        (msg91Provider as any).disconnectedCallback();
      }
      msg91Provider.remove();
    } catch (e) {
      console.error("Error removing MSG91 provider:", e);
    }
  }

  // Don't remove the script - re-loading it causes "h-captcha has already been used"
  // (CustomElementRegistry keeps registrations; they can't be re-defined). Removing
  // the DOM elements below is enough to hide the captcha on other pages.

  // Clear captcha container
  const captchaElement = document.getElementById(CAPTCHA_RENDER_ID);
  if (captchaElement) {
    captchaElement.innerHTML = "";
  }

  // Remove hCaptcha iframes (MSG91 uses hCaptcha - these can persist in body)
  document.querySelectorAll('iframe[src*="hcaptcha"]').forEach((el) => el.remove());
  document.querySelectorAll('iframe[src*="newassets.hcaptcha"]').forEach((el) => el.remove());

  // Note: MSG91 defines window methods as read-only, so we don't overwrite them.
  // Removing the script and DOM elements is sufficient to stop captcha from
  // rendering on other pages.
};

export const MSG91_CONFIG = {
  widgetId: "346b79686352303336343033",
  tokenAuth: "365375TaYB4FU32WrR67443055P1",
  captchaRenderId: "captcha-id",
  exposeMethods: true,
  success: () => {},
  failure: (error: any) => console.error("OTP Verification Failed:", error),
};
